import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { from, switchMap } from "rxjs";

import { environment } from "../../environments/environment";
import { AMPLIFY_AUTH } from "./amplify-auth.token";

// Attaches a Bearer token to outgoing requests targeting the backend service
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const backendUrl = environment.interactiveExperienceServiceUrl;

    // Pass through requests not destined for our backend
    if (!req.url.startsWith(backendUrl)) {
        return next(req);
    }

    const { fetchAuthSession } = inject(AMPLIFY_AUTH);

    // Fetch the current Cognito session and inject the access token
    return from(fetchAuthSession()).pipe(
        switchMap(session => {
            const token = session.tokens?.accessToken?.toString();

            // If no token is available, forward the request unauthenticated
            if (!token) {
                return next(req);
            }

            return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
        })
    );
};
